import {RouteObject, RouterContextProvider, redirect} from 'react-router';

import {EResellerIds, getTenantData} from 'src/containers/User';
import {getDispatch} from 'src/routerContext';

import {EMessageMatchersTab} from './definitions';

const checkBlrReseller = async (context: RouterContextProvider) => {
  const dispatch = getDispatch(context);
  const {data: tenant} = await dispatch(getTenantData.initiate());

  if (!tenant) {
    return false;
  }

  return [EResellerIds.BLR_FIRST_ID, EResellerIds.BLR_SECOND_ID].includes(tenant.resellerId);
};

const blrPathLoader = async (context: RouterContextProvider) => {
  const isBLRReseller = await checkBlrReseller(context);

  if (!isBLRReseller) {
    return null;
  }

  throw redirect(`../${EMessageMatchersTab.LIST}`);
};

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EMessageMatchersTab.LIST),
  },
  {
    path: EMessageMatchersTab.LIST,
    lazy: async () => ({
      Component: (await import('./')).MessageMatcherList,
    }),
  },
  {
    path: EMessageMatchersTab.PRESETS,
    loader: async ({context}) => blrPathLoader(context),
    lazy: async () => ({
      Component: (await import('src/containers/MessageMatcherPresets')).MessageMatcherPresets,
    }),
  },
];

export const messageMatchersRoutes: RouteObject = {
  loader: async ({context}) => {
    const availableTabs: EMessageMatchersTab[] = [EMessageMatchersTab.LIST];
    const isBLRReseller = await checkBlrReseller(context);

    if (!isBLRReseller) {
      availableTabs.push(EMessageMatchersTab.PRESETS);
    }

    return {
      tabs: availableTabs,
    };
  },
  children,
};
